<template>
  <div>
    <nav id="sidebar" v-if="(desktop || largeDesktop) && showMenu">
      <div>
        <ul class="cd-accordion-menu">
          <item
            :key="index"
            v-for="(menu, index) in targetMenu"
            :menu="menu"></item>
        </ul>
      </div>
      <div class="m-1"><p class="version">{{ version }}</p></div>
    </nav>
    <b-sidebar v-if="mobile || tablet" v-model="sidebar_model" id="sidebar-mobile" :width="tablet ? '50%' : ''" shadow>
      <template v-slot:title>
        <div class="d-flex flex-nowrap align-items-center justify-content-between">
          <img class="mr-3" src="../assets/logo.svg"/>
          <span class="mr-1">Fill-Bill</span>
          <div class="mr-1">
            <span>|</span>
          </div>
          <span>Личный кабинет</span>
        </div>
      </template>
      <div>
        <ul class="cd-accordion-menu">
          <item
            :key="index"
            v-for="(menu, index) in targetMenu"
            :menu="menu"></item>
        </ul>
      </div>
      <template v-slot:footer>
        <div class="m-1"><p class="version">{{ version }}</p></div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import Item from './Item'
import menu from './menu.js'
import { mapActions, mapMutations, mapState } from 'vuex'
import axios from 'axios/index'

export default {
  name: 'left-sidebar',
  data () {
    return {
      version: null,
      targetMenu: [],
      userMenu: menu.userMenu,
      adminMenu: menu.adminMenu,
      sidebar_model: true
    }
  },
  components: {
    Item
  },
  beforeMount () {
    window.onpopstate = () => {
      if (this.$route.meta.title === 'user') {
        this.goToUserPart()
        localStorage.setItem('isAdminPart', this.isAdminPart)
      }
      if (this.$route.meta.title === 'admin') {
        this.goToAdminPart()
        localStorage.setItem('isAdminPart', this.isAdminPart)
      }
    }
  },
  mounted () {
    if (localStorage.getItem('isAdminPart') === 'true') {
      if (!this.isAdminPart) {
        this.goToAdminPart()
      }
      this.prepareMenu(this.userInfo, 'admin')
    } else if (this.userInfo.rights.menu_admin.length > 0 && this.userInfo.rights.menu_user.length === 0) {
      if (!this.isAdminPart) {
        this.goToAdminPart()
      }
      this.prepareMenu(this.userInfo, 'admin')
    } else if (this.$route.meta.title === 'admin') {
      if (!this.isAdminPart) {
        this.goToAdminPart()
      }
      this.prepareMenu(this.userInfo, 'admin')
    } else if (this.$route.meta.title === 'user') {
      this.goToUserPart()
      this.prepareMenu(this.userInfo, 'user')
    }
    if (this.userInfo.rights.menu_user.length > 0 && this.$route.name === 'main-container') {
      for (let i = 0; i < this.userMenu.length; i++) {
        if (this.userInfo.rights.menu_user.indexOf(this.userMenu[i].name) !== -1) {
          if (this.userMenu[i].children.length > 0) {
            // console.log(this.userMenu[i].children[0].name)
            this.$router.push({ name: this.userMenu[i].children[0].name })
            break
          } else {
            // console.log({ name: this.userMenu[i].name })
            this.$router.push({ name: this.userMenu[i].name })
            break
          }
        }
      }
    }
    localStorage.setItem('isAdminPart', this.isAdminPart)
    if (this.desktop && this.$route.name !== 'main-container') {
      this.hideMenu()
    }
    if (this.desktop && this.$route.name === 'main-container') {
      this.displayMenu()
    }
  },
  computed: {
    ...mapState(
      {
        userInfo: state => state.authorization.userInfo,
        isAdminPart: state => state.isAdminPart,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        showMenu: state => state.showMenu
      }
    )
  },
  methods: {
    ...mapActions({}),
    ...mapMutations({
      goToAdminPart: 'goToAdminPart',
      goToUserPart: 'goToUserPart',
      hideMenu: 'hideMenu',
      displayMenu: 'displayMenu'
    }),
    prepareMenu (items, target) {
      let rights = (target === 'user' ? items.rights.menu_user : target === 'admin' ? items.rights.menu_admin : [])
      rights = rights.filter((a, b) => rights.indexOf(a) === b)
      const menuList = (target === 'user' ? this.userMenu : target === 'admin' ? this.adminMenu : [])
      const tree = []
      for (let i = 0; i < rights.length; i++) {
        const name = rights[i]
        const dataTraverse = (currentMenuList, parent) => {
          currentMenuList.forEach(function (item) {
            if (item.name === name && item.parent_id === null) {
              tree.push(item)
            }
            if (item.name === name && item.parent_id !== null) {
              const treeItem = tree.filter(index => index.name === parent.name)
              if (treeItem.length === 0) {
                const newItem = Object.assign({}, parent)
                newItem.children = []
                newItem.children.push(item)
                tree.push(newItem)
              } else {
                const treeItemAlreadyHasItem = treeItem[0].children.filter(index => index.name === item.name)
                if (treeItemAlreadyHasItem.length === 0) {
                  treeItem[0].children.push(item)
                }
              }
            }
            if (item.children && item.children.length > 0) {
              dataTraverse(item.children.slice(), item)
            }
          })
        }
        dataTraverse(menuList, null)
      }
      this.sortMenuInRightsOrder(menuList, tree)
    },
    sortMenuInRightsOrder (menuList, tree) {
      this.targetMenu = []
      const rightsInOrder = []
      menuList.forEach((item) => {
        rightsInOrder.push(item.name)
      })
      for (let i = 0; i < rightsInOrder.length; i++) {
        for (let j = 0; j < tree.length; j++) {
          if (rightsInOrder[i] === tree[j].name) {
            this.targetMenu.push(tree[j])
          }
        }
      }
    }
  },
  watch: {
    isAdminPart (to, from) {
      if (to) {
        this.prepareMenu(this.userInfo, 'admin')
      } else {
        this.prepareMenu(this.userInfo, 'user')
      }
    },
    '$route' (to, from) {
      if (to.meta.title === 'user' && !this.isAdminPart) {
        this.prepareMenu(this.userInfo, 'user')
      }
      if (to.meta.title === 'user' && this.isAdminPart) {
        this.prepareMenu(this.userInfo, 'admin')
      }
      if (to.meta.title === 'admin') {
        this.prepareMenu(this.userInfo, 'admin')
      }
      if (this.desktop && to.name !== 'main-container') {
        this.hideMenu()
      }
      if (this.desktop && to.name === 'main-container') {
        this.displayMenu()
      }
    },
    mobile (to, from) {
      // console.log(to)
    },
    tablet (to, from) {
      // console.log(to)
    },
    desktop (to, from) {
      // console.log(to)
    },
    largeDesktop (to, from) {
      // console.log(to)
    }
  },
  created () {
    axios.get('about.json').then(
      result => {
        this.version = result.data.version.branch + '.' + result.data.version.pipeline + '-' + result.data.version.commit
      },
      error => {
        console.log('Rejected: ' + error)
      }
    )
  }
}
</script>

<style scoped>
  ul {
    padding-left: 0px;
    line-height: 1.5em;
    list-style-type: none;
    margin: 0;
  }

  .version {
    color: #90a4ae;
    margin-left: 50px;
    font-size: 12px;
    margin-bottom: 0;
  }

  #sidebar {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
    height: 100vh;
    flex-grow: 1;
    background: #ECEFF1;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media screen
  and (min-width: 1024px)
  and (max-width: 1439px) {
    #sidebar {
      min-width: 215px;
      width: 215px;
      max-width: 215px;
    }
  }

  @media screen
  and (min-width: 1440px) {
    #sidebar {
      min-width: 315px;
      width: 315px;
      max-width: 315px;
    }
  }
</style>
